import { fromGrossMassValidationResponse } from '../models/mapper'
import { GrossMassValidationResult } from '../models/request'
import { validateGrossMassV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function validateGrossMass(id: number): Promise<GrossMassValidationResult> {
  const response = await validateGrossMassV3(id)
  return fromGrossMassValidationResponse(response)
}
